
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lwmqr_im8v7_5"
};
  